import * as React from "react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"
import { Check, Minus } from "@/components/icons"

import { cn } from "@/lib/utils"

function Checkbox({
  ref,
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "group/checkbox relative grid place-content-center peer h-4 w-4 shrink-0 max-md:after:absolute max-md:after:-inset-3.5 max-md:after:content-[''] rounded-sm border border-input bg-card focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-action-fill data-[state=checked]:text-action-fill-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-action-fill data-[state=indeterminate]:text-action-fill-foreground",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("grid place-content-center text-current")}
      >
        <Check className="h-4 w-4 group-data-[state=indeterminate]/checkbox:hidden" />
        <Minus className="hidden h-4 w-4 group-data-[state=indeterminate]/checkbox:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox }
